import React from 'react';
import { Classes, PopoverInteractionKind } from '@blueprintjs/core';
import { Box, Flex, Popover, Text } from 'core/components';
import { getMetricThresholds } from '@kentik/ui-shared/synthetics/formatThreshold';
import { toLabel } from '@kentik/ui-shared/synthetics/utils';

const MetricThresholdPopover = ({ metric, metricValue, healthSettings, rollingStats, children }) => {
  const thresholds = getMetricThresholds(metric, healthSettings, rollingStats);

  if (!thresholds) {
    return children;
  }

  const { warningDisplay, criticalDisplay, isInverted, unit } = thresholds;
  const symbol = isInverted ? '\u2264' : '\u2265';

  return (
    <Popover
      minimal={false}
      interactionKind={PopoverInteractionKind.HOVER}
      content={
        <Box p={2} maxWidth={300} className={Classes.TEXT_SMALL}>
          <Text as="div" fontWeight="bold" mb={1}>
            {toLabel(metric)}
          </Text>
          {metricValue && (
            <Text as="div" mb={1}>
              Observed: {metricValue}
              {unit && !String(metricValue).endsWith(unit) ? ` ${unit}` : ''}
            </Text>
          )}
          <Box borderTop="thin" pt={1} mt={1}>
            <Flex alignItems="center" gap="4px" mb="2px">
              <Box width={8} height={8} borderRadius="50%" bg="warning" flexShrink={0} />
              <Text>
                Warning {symbol} {warningDisplay}
              </Text>
            </Flex>
            <Flex alignItems="center" gap="4px">
              <Box width={8} height={8} borderRadius="50%" bg="danger" flexShrink={0} />
              <Text>
                Critical {symbol} {criticalDisplay}
              </Text>
            </Flex>
          </Box>
          <Text as="div" mt={1} muted fontStyle="italic" fontSize="11px">
            Based on current test settings
          </Text>
        </Box>
      }
    >
      {children}
    </Popover>
  );
};

export default MetricThresholdPopover;
